var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchukoEu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 41.576,
    viewBox: "0 0 42 41.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cad0e4;}.b,.c{fill:#353841;}.d,.e{stroke:none;}.e{fill:#71778a;}.f{filter:url(#e);}.g{filter:url(#c);}.h{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 16,
    y: 15.491,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 1.187,
    y: 12.8,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 25.187,
    y: 12.8,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164 -718.509)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-6329-3147.424h0a20.789,20.789,0,0,1-11.849-5.94,20.868,20.868,0,0,1-6.152-14.85,20.979,20.979,0,0,1,5.184-13.813A20.987,20.987,0,0,1-6329-3189v2.491a3,3,0,0,0,3,3,3,3,0,0,0,3-3V-3189a20.98,20.98,0,0,1,12.816,6.972,20.972,20.972,0,0,1,5.184,13.813,20.868,20.868,0,0,1-6.15,14.85,20.775,20.775,0,0,1-11.849,5.939v-2.084a3,3,0,0,0-3-3,3,3,0,0,0-3,3v2.084Z",
    transform: "translate(6511 3907.509)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 164, 718.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2,0A2,2,0,1,1,0,2,2,2,0,0,1,2,0Z",
    transform: "translate(19 18.49)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, 164, 718.51)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(4.19 15.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, 164, 718.51)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(28.19 15.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchukoEu);
export default __webpack_public_path__ + "static/media/schuko_eu.ff8738a97f094ab37030fe67b34b2a66.svg";
export { ForwardRef as ReactComponent };